import VIDEO_PLAYBACK_STATUSES from 'widget/constants/video-playback-status';

export const isVideoPaused = state => state.videoPlaybackStatus === VIDEO_PLAYBACK_STATUSES.PAUSED;
export const isVideoEnded = state => state.videoPlaybackStatus === VIDEO_PLAYBACK_STATUSES.ENDED;
export const isVideoPlaying = state => state.videoPlaybackStatus === VIDEO_PLAYBACK_STATUSES.PLAYING;



// WEBPACK FOOTER //
// ./src/widget/selectors/video-playback-status.js